module.exports = __webpack_public_path__ + "static/media/icon_3people.f73112fb.svg";